













import { Vue, Component } from 'vue-property-decorator';
import { changeLocale } from '@/app/locale/change-locale';
import rootModule from '@/app/shared/state/root';
import { LOCALES } from '@/locales/default-locale'

@Component
export default class LocaleSelectorComponent extends Vue {
  public get locales(): string[] {
    return LOCALES.split(',');
  }

  public get selectedLocale(): string {
    return rootModule.selectedLocale;
  }

  public changeLocale(locale: string): void {
    changeLocale(locale)
  }
}
